module.exports = __webpack_public_path__ + "img/bg2.204e72b0.png";